<template>
    <div class="border-t pt-3">
        <!-- TODO: if a pro is click, link to their storefront -->
        <div class="ml-4 xl:ml-8 mr-7 mb-2">
            <div
                class="xl:mb-0 flex items-start"
                @click="goToProStoreFront"
                role="button"
            >
                <!-- <svg-vue icon="avatar" class="w-6 h-6 inline-block mr-2 default-avatar-icon hover:cursor-default" /> -->
                <img
                    v-show="!showingDefaultAvatar"
                    @load="showingDefaultAvatar = false"
                    :src="pro.avatar_uri"
                    :alt="`${pro.display_name}'s avatar`"
                    class="w-9 h-9 mr-4 rounded-full max-w-none default-avatar-icon"
                    :class="
                        pro.type == 'pro'
                            ? pro.care_score > 3
                                ? pro.care_score >= 5
                                    ? 'badgeBlue'
                                    : 'badgeGreen'
                                : ''
                            : ''
                    "
                />
                <svg-vue
                    v-show="showingDefaultAvatar"
                    icon="circle-user"
                    title="default user avatar"
                    class="h-9 mr-4 hover:cursor-pointer"
                    :class="
                        pro.type == 'pro'
                            ? pro.care_score > 3
                                ? pro.care_score >= 5
                                    ? 'fill-salesium-blue'
                                    : 'fill-salesium-green'
                                : ''
                            : ''
                    "
                />
                <div class="md:text-base text-hint font-bold">
                    {{ pro.display_name }}
                </div>
            </div>

            <div class="ml-8">
                <div class="flex items-center" v-if="pro.industry">
                    <div class="h-4 w-4 mr-3 inline-block ml-2">
                        <svg-vue
                            :icon="industryIcons[pro.industry.name].icon"
                            class="fill-black"
                        />
                    </div>
                    <p class="text-hint">{{ subindustryString }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { industryIcons } from "../../../constants/industryIcons";
export default {
    props: ["pro"],
    data() {
        return {
            industryIcons,
            showingDefaultAvatar: true,
        };
    },
    methods: {
        goToProStoreFront() {
            window.location = "/storefront/" + this.pro.username;
        },
    },
    computed: {
        subindustryString() {
            if (this.pro.subindustry != null) {
                return this.pro.subindustry.tag
                    .replaceAll("_", " ")
                    .substring(1);
            } else {
                return " ";
            }
        },
    },
};
</script>

<style scoped>
.badgeBlue {
    border-width: 4px;
}
.badgeGreen {
    border-width: 4px;
}
</style>
